<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>{{this.routerQuery.video_id == -99 ? '添加视频' :'编辑视频'}}</span>
      <el-button type="primary"
                 style="width:92px;"
                 size="medium"
                 @click="back">返回</el-button>
    </div>
    <div style="padding: 20px; border-radius: 5px;">
      <div class="container">
        <el-form :model="videoForm"
                 :rules="rules"
                 ref="videoFormRef"
                 label-width="100px"
                 class="demo-videoForm">
          <el-form-item label="视频标题"
                        prop="video_title">
            <el-input v-model="videoForm.video_title"
                      size="small"
                      maxlength="50"
                      clearable
                      placeholder="请输入视频标题"></el-input>
          </el-form-item>

          <el-form-item label="视频"
                        prop="video_url"
                        class="video-url">
            <UploadVideo videoBaseUrl=""
                         :videos="videoForm.videoList"
                         @change="uploadVideoBtn">

              <div class="prompt">视频格式只支持mp4,200M以内</div>
            </UploadVideo>
          </el-form-item>

          <el-form-item label="封面"
                        prop="mian_url"
                        class="mian-url">
            <UploadImg :f_thumb="videoForm.mian_url"
                       :f_thumb_str="videoForm.mian_url_str"
                       @emitImg="mianUrlBtn"></UploadImg>
            <div class="prompt">支持jpg、png、jpeg格式,15M以内</div>
          </el-form-item>

          <el-form-item label="关联医生"
                        prop="doctor_list"
                        class="doctor-list">

            <draggable v-model="videoForm.doctor_list"
                       style="display: inline-block;">
              <transition-group name="flip-list"
                                tag="div"
                                class="tag-box">
                <div v-for="(item,index) in videoForm.doctor_list"
                     :key="index">
                  <el-tag closable
                          size="samll"
                          :disable-transitions="false"
                          @close="handleCasesClose(item)">
                    {{item.doctor_name}}
                  </el-tag>
                </div>
              </transition-group>
            </draggable>
            <el-button v-if="videoForm.doctor_list.length < 8"
                       type="primary"
                       size="small"
                       @click="addDoctorBtn">选择医生</el-button>
          </el-form-item>

          <el-form-item label="关联疾病"
                        prop="be_good_at_list"
                        id="begoodatitem">
            <div class="selectgoodlist"
                 id="begoodat"
                 @click="showgoodlist = true">
              <el-tag :key="index"
                      v-for="(tag, index) in videoForm.be_good_at_list"
                      type="info"
                      closable
                      :disable-transitions="false"
                      @close="handleClose(tag)">{{ tag.be_good_at_name }}</el-tag>
            </div>

            <div class="goodlist"
                 v-if="showgoodlist">
              <div class="search">
                <el-input placeholder="请输入内容"
                          v-model="goodlistKeyword"
                          class="input-with-select"
                          clearable>
                  <el-button slot="append"
                             icon="el-icon-search"
                             @click="getGoodList"></el-button>
                </el-input>
              </div>
              <div class="item"
                   v-for="(item, index) in goodList"
                   :key="index">
                <div class="itemtitle">{{ item.department_name }}</div>
                <div class="gooditembox">
                  <div v-for="(i, ind) in item.list"
                       :key="ind"
                       :class="i.isCheck ? 'checkitem' : 'gooditem'"
                       @click="checkItem(i)">
                    {{ i.be_good_at_name }}
                  </div>
                </div>
              </div>
              <div class="closegood"
                   @click="closegoodlist">关闭</div>
            </div>

          </el-form-item>

          <el-form-item label="虚拟点赞数"
                        prop="virtually_like">
            <el-input-number v-model="videoForm.virtually_like"
                             size="small"
                             :min="0"
                             :max="999999999"
                             :precision="0"
                             :controls="false"></el-input-number>
          </el-form-item>
          <el-form-item label="虚拟分享数"
                        prop="virtually_share">
            <el-input-number v-model="videoForm.virtually_share"
                             size="small"
                             :min="0"
                             :max="999999999"
                             :precision="0"
                             :controls="false"></el-input-number>
          </el-form-item>
          <el-form-item label="虚拟收藏数"
                        prop="virtually_collect">
            <el-input-number v-model="videoForm.virtually_collect"
                             size="small"
                             :min="0"
                             :max="999999999"
                             :precision="0"
                             :controls="false"></el-input-number>
          </el-form-item>
          <el-form-item label="视频简介"
                        prop="video_desc"
                        class="video-desc">
            <el-input v-model="videoForm.video_desc "
                      type="textarea"
                      size="small"
                      :rows="11"
                      maxlength="500"
                      show-word-limit
                      placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button @click=" back">取 消</el-button>
            <el-button type="primary"
                       @click="submitForm('videoFormRef')">确 定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 选择医生弹框 -->
    <choose-doctor :recommendDoctorTableDia.sync="recommendDoctorTableDia"
                   @confirmDoctor="confirmDoctor"></choose-doctor>
  </div>
</template>
<script>
import doctor from '@/api/doctor';
import imgtext from '@/api/imgtext';
import UploadImg from '@/components/uploadImg/index';
import UploadVideo from '@/components/uploadVideo/index';
import draggable from 'vuedraggable';
import ChooseDoctor from '@/components/chooseDoctor/index';
export default {
  components: {
    UploadImg,
    draggable,
    ChooseDoctor,
    UploadVideo
  },
  data() {
    return {
      videoForm: {
        video_title: '',
        video_url: '',
        video_url_str: '',
        videoList: [],
        mian_url: '',
        mian_url_str: '',
        virtually_like: undefined,
        virtually_share: undefined,
        virtually_collect: undefined,
        video_desc: '',
        doctor_list: [],
        be_good_at_list: []
      },
      rules: {
        video_title: [{ required: true, message: '请输入', trigger: 'blur' }],
        video_url: [{ required: true, message: '请上传', trigger: 'change' }],
        mian_url: [{ required: true, message: '请上传', trigger: 'change' }]
      },
      showgoodlist: false,
      goodList: [],
      goodlistKeyword: '',
      recommendDoctorTableDia: false
    };
  },

  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    routerQuery() {
      return this.$route.query;
    }
  },
  created() {
    this.getGoodList();
    this.getVideoInfo();
  },
  methods: {
    // 获取详情
    getVideoInfo() {
      if (this.routerQuery.video_id == -99) {
        return;
      }
      imgtext
        .getVideoInfo({ video_id: this.routerQuery.video_id })
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            let info = _.pick(data.info, [
              'video_title',
              'video_url',
              'video_url_str',
              'mian_url',
              'mian_url_str',
              'virtually_like',
              'virtually_share',
              'virtually_collect',
              'video_desc',
              'doctor_list',
              'be_good_at_list'
            ]);
            info.videoList = [
              {
                isShowPopup: false,
                video_url: info.video_url,
                video_url_str: info.video_url_str
              }
            ];
            this.videoForm = JSON.parse(JSON.stringify(info));
          }
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = _.omit(this.videoForm, [
            'be_good_at_list',
            'doctor_list',
            'videoList',
            'mian_url_str',
            'video_url_str'
          ]);
          params.be_good_at_list = this.videoForm.be_good_at_list.map(
            (item) => item.be_good_at_id
          );
          params.doctor_list = this.videoForm.doctor_list.map(
            (item) => item.doctor_id
          );
          let interfaceName =
            this.routerQuery.video_id == -99 ? 'createVideo' : 'editVideo';
          if (interfaceName == 'editVideo') {
            params.video_id = this.routerQuery.video_id;
          }
          imgtext[interfaceName](params).then((res) => {
            let { code } = res;
            if (code === 0) {
              this.$message.success('保存成功');
              this.back();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 视频
    uploadVideoBtn(list) {
      this.videoForm.video_url = list[0].video_url;
      this.videoForm.video_url_str = list[0].video_url_str;
      this.videoForm.videoList = JSON.parse(JSON.stringify(list));
      this.$refs['videoFormRef'].validateField('video_url');
    },
    // 封面
    mianUrlBtn(data) {
      this.videoForm.mian_url = data.pic;
      this.videoForm.mian_url_str = data.path;
      this.$refs['videoFormRef'].validateField('mian_url');
    },
    //获取医生擅长列表
    getGoodList() {
      doctor
        .getDoctorBeGoodsAt({ be_good_at_name: this.goodlistKeyword })
        .then((res) => {
          this.goodList = res.data.list.map((item) => {
            item.list.map((i) => {
              i.isCheck = false;
              return i;
            });
            return item;
          });

          let check_id = this.videoForm.be_good_at_list.map((item) => {
            return item.be_good_at_id;
          });
          this.goodList.forEach((item) => {
            item.list.forEach((i) => {
              i.isCheck = false;
              if (check_id.includes(i.be_good_at_id)) {
                i.isCheck = true;
              }
            });
          });
        });
    },
    //选择擅长列表里面的
    checkItem(i) {
      if (this.videoForm.be_good_at_list.length == 3 && !i.isCheck) {
        this.$message.warning('最多可选择3个疾病');
        return;
      }
      i.isCheck = !i.isCheck;
      if (i.isCheck) {
        this.videoForm.be_good_at_list.push(i);
        this.$nextTick(() => {
          let h = document.getElementById('begoodat').offsetHeight;
          document.getElementById('begoodatitem').style.marginBottom =
            h - 20 + 'px';
        });
      } else {
        this.videoForm.be_good_at_list.splice(
          this.videoForm.be_good_at_list.indexOf(i),
          1
        );
        this.$nextTick(() => {
          let h = document.getElementById('begoodat').offsetHeight;
          document.getElementById('begoodatitem').style.marginBottom =
            h - 20 + 'px';
        });
      }
    },
    //删除单个标签
    handleClose(tag) {
      this.videoForm.be_good_at_list.splice(
        this.videoForm.be_good_at_list.indexOf(tag),
        1
      );
      this.$nextTick(() => {
        let h = document.getElementById('begoodat').offsetHeight;
        document.getElementById('begoodatitem').style.marginBottom =
          h - 30 + 'px';
      });
      let check_id = this.videoForm.be_good_at_list.map((item) => {
        return item.be_good_at_id;
      });
      this.goodList.forEach((item) => {
        item.list.forEach((i) => {
          i.isCheck = false;
          if (check_id.includes(i.be_good_at_id)) {
            i.isCheck = true;
          }
        });
      });
    },
    //关闭擅长列表
    closegoodlist() {
      this.showgoodlist = false;
      this.goodlistKeyword = '';
      this.getGoodList();
    },
    // 选择医生
    addDoctorBtn() {
      this.recommendDoctorTableDia = true;
    },
    confirmDoctor(data) {
      let doctor_arr = data.map((item) => {
        let obj = {
          doctor_id: item.doctor_id,
          doctor_name: item.doctor_name
        };
        return obj;
      });
      let arr = _.uniqBy(
        [...doctor_arr, ...this.videoForm.doctor_list],
        'doctor_id'
      );
      if (arr.length > 8) {
        this.$message.warning('最多可选择8个医生');
        return;
      }
      this.videoForm.doctor_list = JSON.parse(JSON.stringify(arr));
    },
    // 删除医生
    handleCasesClose(tag) {
      this.videoForm.doctor_list.splice(
        this.videoForm.doctor_list.indexOf(tag),
        1
      );
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
  text-align: left;
}
.demo-videoForm {
  width: 900px;
  .selectgoodlist {
    width: 400px;
    min-height: 40px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    border-radius: 4px;
    &:hover {
      border: 1px solid #669961;
    }
    .el-tag {
      margin: 4px;
    }
  }
  .goodlist {
    background: #fff;
    box-sizing: border-box;
    width: 398px;
    height: 300px;
    overflow-y: scroll;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    border: solid 1px #c0c4cc;
    margin-top: 10px;
    z-index: 100000000;
    position: relative;
    .search {
      background-color: #fff;
      padding: 4px;
      position: sticky;
      top: 0;
    }
    .item {
      margin-bottom: 24px;
      padding: 0 5px 0 20px;
    }
    .closegood {
      height: 30px;
      line-height: 30px;
      width: 378px;
      background-color: #e6efeb;
      color: #699b64;
      text-align: center;
      cursor: pointer;
      position: sticky;
      bottom: 0px;
    }
    .itemtitle {
      color: #191c21;
      font-weight: 600;
      height: 30px;
      line-height: 30px;
    }
    .gooditembox {
      display: flex;
      flex-wrap: wrap;
      .gooditem {
        margin-right: 10px;
        cursor: pointer;
        height: 30px;
        line-height: 30px;
        margin-bottom: 6px;
        padding: 0 5px;
        box-sizing: border-box;
      }
    }
    .checkitem {
      background-color: #e6efeb;
      margin-right: 10px;
      cursor: pointer;
      height: 30px;
      line-height: 30px;
      color: #669961;
      margin-bottom: 6px;
      padding: 0 5px;
      box-sizing: border-box;
    }
  }
  .video-desc {
    ::v-deep .el-form-item__content {
      height: 230px;
    }
  }
  .flip-list-move {
    transition: transform 0.5s;
  }
  .no-move {
    transition: transform 0s;
  }
  .doctor-list {
    .tag-box {
      display: flex;
      flex-wrap: wrap;
      .el-tag {
        margin-bottom: 4px;
        margin-right: 10px;
        cursor: pointer;
      }
    }
  }
  .mian-url {
    height: 130px;
    ::v-deep .el-form-item__content {
      height: 100%;
    }
  }
  .video-url {
    height: 130px;
    ::v-deep .el-form-item__content {
      height: 100%;
    }
  }
}
</style>
